import moment from '@/moment-gp'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {},
  staticActions: {},

  schema: {
    create({ email = null, receiverUserId = null, invitationCode = null }, data) {

      // Syntax: create({ email, invitationCode, <appContent> })
      // - or-
      //         create({ receiverUserId, <appContent> })

      if ( !email && !receiverUserId ) {
        throw new Error('Either email or receiver id must be present')
      }
      let outgoingInvitation = {
        createdAt: moment.currentTimeServer('REALTIMEDB'),
        cachedAppContent: data.appContent ? JSON.stringify(data.appContent) : '',
      }
      if ( email ) {
        outgoingInvitation['email'] = email;
        outgoingInvitation['invitationCode'] = invitationCode;
      }
      if ( receiverUserId ) {
        outgoingInvitation['receiverUserId'] = receiverUserId;
      }
      return outgoingInvitation
    },

    fields: {
      createdAt: { validate_bolt_type: 'ServerTimestamp' },
      email: { validate_bolt_type: 'EMail' },
      cachedAppContent: { validate_bolt_type: 'String' },
      receiverUserId: { validate_bolt_type: 'UserID' },
      invitationCode: { validate_bolt_type: 'InvitationCode' },
    }
  }
};
